import React, {useState, useRef, forwardRef, useImperativeHandle} from 'react';
import {Modal, Form, Input, notification, Checkbox, Radio, Button} from 'antd';
import PropTypes from 'prop-types';
import styles from './index.module.less';
import TagGroup from 'page/admin/InterceptRulePage/TagGroup/TagGroup';
import DepartUserTagSelector from '@/page/admin/selector/DepartUserTagSelector';
import _ from 'lodash';
import {CheckOutlined} from '@/icons';
import {addIntercept, updateIntercept} from '@/api/sensitive';

const {Item} = Form;
const CheckboxGroup = Checkbox.Group;

const semanticOptions = [
    {label: '手机号', value: 1},
    {label: '邮箱地', value: 2},
    {
        label: '红包',
        value: 3,
    },
];

const RuleModal = forwardRef(({reload = () => {}}, ref) => {
    // 0 add 1 edit 2 view
    const [type, setType] = useState(null);
    const [visible, setVisible] = useState(false);
    const [semvisible, setSemvisible] = useState(true);
    const [needEmail, setNeedEmail] = useState(false);
    const [intercepts, setIntercepts] = useState([]);
    const [selData, setSelData] = useState({});
    const [tags, setTags] = useState([]);
    const [emails, setEmails] = useState([]);
    const selectorRef = useRef();
    const [form] = Form.useForm();

    useImperativeHandle(ref, () => ({
        open,
    }));

    function handleOk() {
        if (type != 2) {
            form.validateFields()
                .then(values => {
                    let {range, ...postData} = {...values};
                    postData.semanticsIds = _.isEmpty(postData.semanticsIds)
                        ? []
                        : postData.semanticsIds;
                    postData.rangeUserIds = _.isEmpty(selData.users)
                        ? []
                        : selData.users.map(user => user.id);
                    postData.rangeStringDepIds = _.isEmpty(selData.departs)
                        ? []
                        : selData.departs.map(depart => depart.id);
                    if (type === 1) {
                        console.log('pppppp', postData);
                        updateIntercept(postData).then(res => {
                            if (res.data.errcode === 0) {
                                notification.success({
                                    message: '设置成功',
                                });
                                reload();
                                setVisible(false);
                            } else {
                                notification.error({
                                    message: '设置失败',
                                    description: (
                                        <>
                                            <p>{'错误码：' + res.data.errcode}</p>
                                            <a
                                                href={
                                                    'https://open.work.weixin.qq.com/devtool/query?e=' +
                                                    res.data.errcode
                                                }
                                                target="_blank"
                                            >
                                                点击查询具体错误
                                            </a>
                                        </>
                                    ),
                                });
                            }
                        });
                    } else {
                        addIntercept(postData).then(res => {
                            if (res.data.errcode === 0) {
                                notification.success({
                                    message: '设置成功',
                                });
                                reload();
                                setVisible(false);
                            } else {
                                notification.error({
                                    message: '设置失败',
                                    description: (
                                        <>
                                            <p>{'错误码：' + res.data.errcode}</p>
                                            <a
                                                href={
                                                    'https://open.work.weixin.qq.com/devtool/query?e=' +
                                                    res.data.errcode
                                                }
                                                target="_blank"
                                            >
                                                点击查询具体错误
                                            </a>
                                        </>
                                    ),
                                });
                            }
                        });
                    }
                })
                .catch(info => {
                    setVisible(true);
                });
        }
    }

    function handleCancel() {
        setVisible(false);
    }

    function open(isEdit, record) {
        if (_.isEmpty(record)) {
            form.resetFields();
            setSelData(null);
            setTags([]);
            setEmails([]);
            setType(!isEdit ? 0 : 1);
        } else {
            setType(!isEdit ? 2 : 1);
            const {match, name, interceptType, semanticsList, depts, users, email, ruleId} = record;
            console.log(',,,', type, record);
            setTags(match.split(','));
            setEmails(_.isEmpty(email) ? [] : email.split(','));
            let tempSelData = {users: [], departs: []};
            depts.length > 0 &&
                depts.map(v => {
                    let dep = {id: v.id, name: v.name};
                    tempSelData.departs.push(dep);
                });
            users.length > 0 &&
                users.map(v => {
                    let user = {id: v.id, name: v.name};
                    tempSelData.users.push(user);
                });
            setSelData(tempSelData);
            if (interceptType === 1) {
                setSemvisible(true);
                setNeedEmail(false);
            }
            if (interceptType === 2) {
                setSemvisible(true);
                setNeedEmail(true);
            }
            if (interceptType === 3) {
                setSemvisible(false);
                setNeedEmail(true);
            }

            let semanticsIds = _.isEmpty(semanticsList)
                ? null
                : semanticsList.split(',').map(val => parseInt(val, 10));
            form.setFieldsValue({
                ruleId,
                name,
                match,
                interceptType,
                semanticsIds: semanticsIds,
                email,
                range: 'exist',
            });
        }
        setVisible(true);
    }

    function getTags(tags) {
        form.setFieldsValue({
            match: tags.toString(),
        });
        setIntercepts(tags);
    }

    function getEmails(emails) {
        form.setFieldsValue({
            email: emails.toString(),
        });
        setEmails(emails);
    }

    function onSelect(values) {
        console.log('onSelect', values, _.isEmpty(values));
        if (_.isEmpty(values)) {
            form.setFieldsValue({
                range: null,
            });
            setSelData(null);
        } else {
            form.setFieldsValue({
                range: 'exist',
            });
            setSelData(values);
        }
        return true;
    }

    function onSelectClick() {
        selectorRef.current.showModal({initialValues: selData});
    }

    function renderSelData() {
        return (
            <>
                {selData.users.length > 0 &&
                    selData.users.map((user, i) => (
                        <span className={styles.name} key={i}>
                            {user.name}
                        </span>
                    ))}
                {selData.departs.length > 0 &&
                    selData.departs.map((depart, i) => (
                        <span className={styles.name} key={i}>
                            {depart.name}
                        </span>
                    ))}
            </>
        );
    }

    return (
        <Modal
            title={
                visible && (
                    <>
                        {type == 0 && '新增规则'}
                        {type == 1 && '编辑规则'}
                        {type == 2 && '查看规则'}
                    </>
                )
            }
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose={true}
        >
            <Form form={form}>
                <Item label="规则ID" name="ruleId" hidden={true}>
                    <Input />
                </Item>
                <Item
                    label="规则名称"
                    name="name"
                    rules={[{required: true, message: '规则名称不能为空'}]}
                >
                    <Input disabled={type == 2} />
                </Item>
                <Item
                    label="敏感词"
                    name="match"
                    rules={[{required: true, message: '敏感词不能为空'}]}
                >
                    <TagGroup getTags={getTags} origin={tags} disabled={type == 2} />
                </Item>
                <Item
                    label="拦截方式"
                    name="interceptType"
                    rules={[{required: true, message: '拦截方式不能为空'}]}
                >
                    <Radio.Group
                        disabled={type == 2}
                        onChange={e => {
                            const type = e.target.value;
                            if (type === 1) {
                                setSemvisible(true);
                                setNeedEmail(false);
                            }
                            if (type === 2) {
                                setSemvisible(true);
                                setNeedEmail(true);
                            }

                            if (type === 3) {
                                setSemvisible(false);
                                setNeedEmail(true);
                            }
                        }}
                    >
                        <Radio value={1}>警告并拦截发送</Radio>
                        <Radio value={2}>仅警告</Radio>
                        <Radio value={3}>仅触发通知</Radio>
                    </Radio.Group>
                </Item>
                {semvisible && (
                    <Item label="其他" name="semanticsIds">
                        <CheckboxGroup options={semanticOptions} disabled={type == 2} />
                    </Item>
                )}
                {needEmail && (
                    <Item label="提醒邮箱地址" name="email">
                        <TagGroup
                            getTags={getEmails}
                            origin={emails}
                            disabled={type == 2}
                            btnText={'新增提醒邮箱'}
                        />
                        {/*<Input disabled={type == 2} />*/}
                    </Item>
                )}
                <Item
                    label="选择范围"
                    name="range"
                    rules={[{required: true, message: '选择范围不能为空'}]}
                >
                    {type == 2 ? (
                        renderSelData()
                    ) : (
                        <Button type="link" icon={<CheckOutlined />} onClick={onSelectClick}>
                            {_.isEmpty(selData)
                                ? '选择规则拦截范围'
                                : `已选择${
                                      _.isEmpty(selData.users) ? 0 : selData.users.length
                                  }个人，${
                                      _.isEmpty(selData.departs) ? 0 : selData.departs.length
                                  }个部门`}
                        </Button>
                    )}
                </Item>
            </Form>
            <DepartUserTagSelector
                ref={selectorRef}
                modalTitle="选择规则拦截范围"
                showAppTagTab={false}
                showTagTab={false}
                onSelect={onSelect}
            />
        </Modal>
    );
});

RuleModal.displayName = 'RuleModal';

RuleModal.propTypes = {
    reload: PropTypes.func,
};

export default RuleModal;
